import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row,
} from "react-bootstrap";
import { RiMailSendFill } from "react-icons/ri";
import { motion } from "framer-motion";

import contactImage from "../assets/images/contact-img.svg";
import { fadeIn } from "../utils/motionVariants";
import getEmailConfig from "../utils/emailConfig";
import { toast } from "react-toastify";

const ContactMe = () => {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const sendMessage = async () => {
    //Validate
    if (!email || !subject || !message) {
      if (!email) {
        toast.error(
          `Please Fill the Email Field for Sending a Message`
        );
      } else if (!subject) {
        toast.error(
          `Please Fill the Subject Field for Sending a Message`
        );
      } else if (!message) {
        toast.error(
          `Please Fill the Message Field for Sending a Message`
        );
      }

      return;
    }

    if (window.Email) {
      window.Email.send(
        getEmailConfig(
          "message@kaamilahamadh.online",
          "mail@kaamilahamadh.online",
          `New Message - From ${email}, Subject - ${subject}`,
          `${message}`
        )
      )
        .then((message) => {
          if (message === "OK") {
            toast.success(
              "Message Successfully Sent"
            );
            setEmail("");
            setSubject("");
            setMessage("");
            return;
          }

          toast.error(message);
          return;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div id="contact" className="mt-5">
      <Container className="text-light">
        <h3 className="text-accent">
          Contact Me
        </h3>
        <hr />

        <Container className="d-flex justify-content-center">
          <Row className="w-100">
            <Col xs={12} lg={6}>
              <motion.div
                variants={fadeIn}
                viewport={{ once: true }}
                initial="hidden"
                whileInView="visible"
                transition={{
                  duration: 1,
                  delay: 0.2,
                }}
                className="h-100"
              >
                <img
                  src={contactImage}
                  alt="contact"
                  className="contact-image"
                />
              </motion.div>
            </Col>
            <Col xs={12} lg={6}>
              <motion.div
                variants={fadeIn}
                viewport={{ once: true }}
                initial="hidden"
                whileInView="visible"
                transition={{
                  duration: 1,
                  delay: 1,
                }}
              >
                <Card className="square border border-3 border-accent rounded-9 mt-5 p-3 w-100">
                  <div className="d-flex justify-content-center">
                    <RiMailSendFill
                      size={25}
                      color="cyan"
                    />
                  </div>
                  <Card.Body>
                    <Card.Title className="text-accent text-center">
                      Contact Me
                    </Card.Title>

                    <br />

                    <FloatingLabel
                      controlId="floatingInput2"
                      label="Email address"
                      className="mb-3 text-light"
                    >
                      <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        value={email}
                        onChange={(e) =>
                          setEmail(e.target.value)
                        }
                        className="bg-transparent text-light"
                        required
                      />
                    </FloatingLabel>

                    <FloatingLabel
                      controlId="floatingInput3"
                      label="Subject"
                      className="mb-3 text-light"
                    >
                      <Form.Control
                        type="text"
                        placeholder="subject"
                        value={subject}
                        onChange={(e) =>
                          setSubject(
                            e.target.value
                          )
                        }
                        className="bg-transparent text-light"
                        required
                      />
                    </FloatingLabel>

                    <FloatingLabel
                      controlId="floatingTextarea2"
                      label="Message"
                      className="mb-3 text-light"
                    >
                      <Form.Control
                        as="textarea"
                        placeholder="Leave a Message here"
                        value={message}
                        onChange={(e) =>
                          setMessage(
                            e.target.value
                          )
                        }
                        style={{
                          height: "200px",
                        }}
                        className="bg-transparent text-light"
                        required
                      />
                    </FloatingLabel>

                    {/* <div className="text-center">
                      <Button
                        variant="accent"
                        className="m-2"
                        onClick={sendMessage}
                      >
                        Send Message
                      </Button>
                    </div> */}

                    <div className="text-center">
                      {/* <div>OR</div> */}

                      <a
                        href={`mailto:kaamilahamadh6@gmail.com?subject=${subject}&body=${message}`}
                      >
                        <Button
                          variant="accent"
                          className="m-2"
                        >
                          Send Mail
                        </Button>
                      </a>
                      <br />
                    </div>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default ContactMe;
